import React from "react";
import Button from "./button";
import Display from "./display";
import "../components.css";


export default function CounterButton ({label = "Label", width = "25vw", height = "25vh", color = "red", pressColor = "gray", value = "", onChange, vertical = false, order = [1, 0, -1]}: {label: string, width: string, height: string, color: string, pressColor: string, value: string, onChange: Function, vertical?: boolean, order?: number[]}) {
    const [number, setNumber] = React.useState(Number(value) || 0);
    const _order = vertical ? order : order.reverse();
    var tileStyle: React.CSSProperties = {
        width: width,
        height: height,
        display: 'flex',
        flexDirection: vertical ? 'column' : 'row',
        alignItems: 'center',
        justifyContent: 'center'
    }

    function increase() {
        setNumber(number + 1);
        onChange(String(number + 1));
        console.log(value)
    }

    function decrease() {
        setNumber(number - 1);
        onChange(number - 1);
    }

    return (
        <div className="tile" style={tileStyle}>
            {_order.map((value, index) => {
                switch (value) {
                    case 1:
                        return (
                            <Button key={index} label="+" width={!vertical ? "33%" : "100%"} height={vertical ? "33%" : "100%"} color={color} pressColor={pressColor} onChange={increase}/>
                        )
                    case 0:
                        return (
                            <Display key={index} label={label + ": " + String(number)} width={!vertical ? "33%" : "100%"} height={vertical ? "33%" : "100%"} text={number.toString()} backgroundColor={color} hideVar={true}/>
                        )
                    case -1:
                        return (
                            <Button key={index} label="-" width={!vertical ? "33%" : "100%"} height={vertical ? "33%" : "100%"} color={color} pressColor={pressColor} onChange={decrease}/>
                        )
                    default:
                        return (
                            <div key={index}></div>
                        )
                }})}
        </div>
    )
}
